<template>
  <div class="page-add">
    <div class="add-title">音频详情</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label="音频内容：" required>
            <av-preview
              :src="videoForm.audioLink"
              type="audio"
              :deleteable="false"
            >
            </av-preview>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="音频集：">
            <el-input readonly v-model="videoForm.audioSetName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="音频名称：" required>
            <el-input v-model="videoForm.audioName" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="音频封面：">
            <av-preview
              v-if="videoForm.coverUrl"
              :src="videoForm.coverUrl"
              type="image"
              :deleteable="false"
            />
            <upload
              v-else
              :draggable="false"
              :path="'audio/img'"
              type="image"
              v-model="videoForm.covers"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle" label-width="0">
            <div class="center-view">
              <back-button :pathOptions="pathOptions" :floatLeft="false" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getAudioInfo } from "@/api/audio";
import AvPreview from "@/components/av-preview/index";
import Upload from "@/components/upload/index";
import BackButton from "@/components/backButton/index.vue";
export default {
  components: { Upload, AvPreview , BackButton },
  data() {
    return {
      pathOptions: {
        path: "/audio",
      },
      videoForm: {
        audioLink: "",
        audioSetName: "",
        audioName: "",
        audioSource: "",
        categoryName: "",
        expireTime: "",
        coverUrl: "",
      },
    };
  },
  created() {
    this.getMapAndDetail();
  },
  methods: {
    async getMapAndDetail() {
      getAudioInfo(this.$route.query.id).then((res) => {
        if (!res || res.code != 0) return;
        const { data } = res;
        this.videoForm = {
          audioSetName: data.audioSetName,
          audioLink: data.audioLink,
          audioName: data.audioName,
          categoryName: data.categoryName,
          audioSource: data.audioSource,
          expireTime: data.expireTime,
          coverUrl: data.coverUrl,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.form-select {
  width: 100%;
  &.has-btn {
    width: calc(100% - 110px);
  }
}
.button-dept {
  margin-left: 10px;
  width: 100px;
}
.progress {
  outline: none;
  border: 1px dashed #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 260px;
  height: 160px;
}
.center-view {
  text-align: center;
}
</style>
